module.exports = __webpack_public_path__ + "img/arrow-top.09dd3f30.svg";